module.exports = __webpack_public_path__ + "static/img/header.68d9d93d.png";